import { render, staticRenderFns } from "./CustomComponent.vue?vue&type=template&id=46512262&"
import script from "./CustomComponent.vue?vue&type=script&lang=js&"
export * from "./CustomComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports